import {Button} from '@/components/ui/button';
import {Toaster} from '@/components/ui/sonner.tsx';
import {getError} from "../lib/errorHandler.ts"

export default function CustomErrorPage() {
    const errorData = getError();
    const { title, errorMessage, buttonLabel, statusCode } = errorData || {
        title: 'An error occurred',
        errorMessage: 'Unexpected error. Please try again later.',
        buttonLabel: 'Back',
        statusCode: undefined
    };
    return (
        <div className="mb-[100px] ml-[70px] mt-[50px]">
            <Toaster richColors />
            <h1 className="max-w-[700px] text-4xl font-bold">{title}</h1>

            <div className="mt-[30px] flex max-w-[700px] flex-col gap-8 text-lg">
                <p className="font-bold">{errorMessage}</p>
                <p className="font-bold">Code: {statusCode ?? 'Unknown'}</p>
                <div className="flex">
                    <Button
                        variant="default"
                        onClick={() => {
                            window.location.href = `/`
                        }}
                    >
                        {buttonLabel}
                    </Button>
                </div>
            </div>
        </div>
    );
}
